import { Container, Row, Col, NavItem, Table } from 'react-bootstrap';
import './trdashboard.css';
import { Link } from 'react-router-dom';

import { DataGrid } from '@mui/x-data-grid';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { authKey, GET_DASAHBOARD_CONSIGNMENT_LIST, GET_DASHBOARD_COUNT} from '../../../common/URLs';
import { Tooltip, Box, Card, IconButton, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab } from '@mui/material';
import { toast } from 'react-toastify';
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { ViewIcon } from '../../../common/icons';
import apiClient from '../../../axios';



function Trdashboard() {
  const navigate = useNavigate();
  const [toBeLoadedCount, setToBeLoadedCount] = useState();
  const [inTransit, setInTransit] = useState();
  const [grnCompleted, setGrnCompleted] = useState();
  const [unloaded, setUnloaded] = useState();
  const [cardSelected, setCardSelected] = useState("ToBeLoaded");

  useEffect(() => {
    if (getLocalStorageItem('id_token')) {
      getCountData();
      loadConsignmentData("ToBeLoaded")
      //getIneventoryDashBoard();
    }
  }, []);




  const loadConsignmentData = (consignmentStatus) => {
    setCardSelected(consignmentStatus);
    apiClient
      .post(GET_DASAHBOARD_CONSIGNMENT_LIST,
        {
          "consignmentType": "HIT",
          "consignmentStatus": consignmentStatus
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        console.log(response?.data?.consignments);
        setRows(response?.data?.consignments);
      })
      .catch(function (error) {
        console.log(error);
        toast.error(error.message);
      });
  }

  const getCountData = () => {
    apiClient
      .post(GET_DASHBOARD_COUNT,
        {
          "consignmentType": "HIT"
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        if (response?.data?.consignmentCount) {
          response?.data?.consignmentCount.forEach(element => {
            if (element?.consignmentStatus === "ToBeLoaded") {
              setToBeLoadedCount(element.count)
            }
            if (element?.consignmentStatus === "InTransit") {
              setInTransit(element.count)
            }
            if (element?.consignmentStatus === "Unloaded") {
              setUnloaded(element.count)
            }
            if (element?.consignmentStatus === "GrnCompleted") {
              setGrnCompleted(element.count);
            }

          });
        }
      })
      .catch(function (error) {
        console.log(error);
        toast.error(error.message);
      });
  }

  const [rows, setRows] = useState([]);

  const columns = [

    { field: 'consignmentNo', headerName: 'Consignment', width: 120 },

    { field: 'consignmentSourceUrn', headerName: 'Consignment Owner URN', width: 200 },

    { field: 'consignmentOwnerName', headerName: 'Consignment Owner Name', width: 200 },

    { field: 'consignmentOwnerContactNo', headerName: 'Consignment Owner Contact', width: 220 },

    { field: 'consignmentWeight', headerName: 'Weight (in MT)', width: 150 },

    {

      field: 'View Details', width: 120,

      renderCell: (cellValues) => {

        return (
<Tooltip title="View">
          <IconButton
            color="primary"
            onClick={() => consignmentDetails(cellValues.row)}
          >

            <ViewIcon />

          </IconButton>
          </Tooltip>
        );

      }

    },

  ];


  const consignmentDetails = (consignment) => {
    if (consignment?.materialType === "RawBamboo") {
      navigate("./Lletracker", {
        state: { selectedConsNo: consignment?.consignmentNo }
      });
    }
    else {
      navigate("./LlePickUpDetails", {
        state: { selectedConsNo: consignment?.consignmentNo }
      });
    }
  }



  return (





    <Container fluid>

      {/* <div className='headingStylePIT' style={{ textAlign: "center" }}>Consignments Status</div> */}


      <Row>
        {/* <Col xs={12} md={12}>

          <div className="consignment-pick-up-consignment-label" >Total Consignments</div>
        </Col> */}

        <Col xs={12} md={4}>
          <div className="card-tr" style={{ backgroundColor: cardSelected === 'ToBeLoaded' ? "rgb(169, 212, 185)" : "whitesmoke" }}>
            <div onClick={() => loadConsignmentData("ToBeLoaded")} style={{ cursor: "pointer", textDecoration: "underline", color: cardSelected === 'ToBeLoaded' ? '#005BAA' : '#89779d', float: "right", marginRight: '1vw', marginTop: '0vh' }}>Click to view list </div>
            <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{toBeLoadedCount}</Typography>
            <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>To be Loaded</Typography>
          </div>
        </Col>
        <Col xs={12} md={4}>
          <div className="card-tr" style={{ backgroundColor: cardSelected === 'InTransit' ? "rgb(169, 212, 185)" : "whitesmoke" }}>
            <div onClick={() => loadConsignmentData("InTransit")} style={{ cursor: "pointer", textDecoration: "underline", color: cardSelected === 'InTransit' ? '#005BAA' : '#89779d', float: "right", marginRight: '1vw', marginTop: '0vh' }}>Click to view list </div>
            <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{inTransit}</Typography>
            <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>In-transit</Typography>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={4}>
          <div className="card-tr" style={{ backgroundColor: cardSelected === 'Unloaded' ? "rgb(169, 212, 185)" : "whitesmoke" }}>
            <div onClick={() => loadConsignmentData("Unloaded")} style={{ cursor: "pointer", textDecoration: "underline", color: cardSelected === 'Unloaded' ? '#005BAA' : '#89779d', float: "right", marginRight: '1vw', marginTop: '0vh', }}>Click to view list</div>
            <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{unloaded}</Typography>
            <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Unloaded</Typography>
          </div>
        </Col>
        <Col xs={12} md={4}>
          <div className="card-tr" style={{ backgroundColor: cardSelected === 'GrnCompleted' ? "rgb(169, 212, 185)" : "whitesmoke" }}>
            <div onClick={() => loadConsignmentData("GrnCompleted")} style={{ cursor: "pointer", textDecoration: "underline", color: cardSelected === 'GrnCompleted' ? '#005BAA' : '#89779d', float: "right", marginRight: '1vw', marginTop: '0vh', }}>Click to view list </div>
            <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{grnCompleted}</Typography>
            <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>GRN Complete</Typography>
          </div>
        </Col>

        <br></br>
        <br></br>


      </Row>


      <br></br>

      <Card>

        <Box style={{ height: 500, width: '100%' }}>

          {/* {

                                    grnListData && */}

          <DataGrid rows={rows}

            columns={columns}

            pageSize={10}




          />

          {/* } */}




        </Box>

      </Card>

    </Container>




  )




}


export default Trdashboard;